// import data from '@/data/data.ts' use if you have a seperate data file

import { GetterTree } from 'vuex'
import { State } from '.'
import { IEntity } from '../interfaces/entity.interface'

const getters: GetterTree<any, any> = {
	entity(state: State): IEntity | null {
		return state.entity
	},
	backupEntity(state: State): IEntity | null {
		return state.backupEntity
	},
	entityType(state: State): 'User' | 'Client' | false {
		if (!state.entity) return false

		return state.entity.type
	},
	entityTestValues(state: State): any {
		return state.entity ? state.entity.testValues ? JSON.parse(state.entity.testValues) : [] : []
	},
	questions(state: State): any[] {
		return state.questions
	},
	privacyStatementSelected(state: State): boolean {
		return state.privacyStatementSelected
	}
}

export default getters
